import React from "react";
import "./card.scss";

interface CardProps {
  children?: React.ReactNode;
  disabled?: boolean;
  width?: string | number;
  height?: string | number;
  className?: string;
}

export default function Card({ 
  children, 
  disabled = false, 
  width,
  height,
  className = ""
}: CardProps) {
  const style: React.CSSProperties & Record<string, any> = {};
  
  if (width !== undefined) {
    style['--card-width'] = typeof width === 'number' ? `${width}px` : width;
  }
  
  if (height !== undefined) {
    style['--card-height'] = typeof height === 'number' ? `${height}px` : height;
  }

  return (
    <div 
      className={`finspace-card-wrapper ${disabled ? 'finspace-card-wrapper--disabled' : ''} ${className}`}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      style={style}
    >
      <div className="finspace-card">{children}</div>
    </div>
  );
}
